var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow1Stroke(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53358 0.285156H16.8142C17.6905 0.285156 18.4009 0.995561 18.4009 1.87189V16.1525C18.4009 17.0288 17.6905 17.7392 16.8142 17.7392C15.9378 17.7392 15.2274 17.0288 15.2274 16.1525V5.7026L2.9763 17.9537C2.35664 18.5734 1.35198 18.5734 0.732322 17.9537C0.112664 17.3341 0.112664 16.3294 0.732322 15.7098L12.9835 3.45862H2.53358C1.65725 3.45862 0.946844 2.74822 0.946844 1.87189C0.946844 0.995561 1.65725 0.285156 2.53358 0.285156Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1Stroke);
export default __webpack_public_path__ + "static/media/Arrow 1 (Stroke).bdf7b78811f3e04cbe12594e9996b394.svg";
export { ForwardRef as ReactComponent };